import { Grid, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LendingServiceResponse } from '@pages/lending/types';
import { useTranslation } from 'react-i18next';
import LendingDetails from './LendingDetails';

interface ResponseConfirmationProps {
  isSuccessful: boolean;
  lendingData: LendingServiceResponse;
}

const ResponseConfirmation = ({
  isSuccessful,
  lendingData,
}: ResponseConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 2, md: 3 }}>
      <Grid item xs={12} className="!mb-5 text-center">
        {isSuccessful ? (
          <CheckCircleIcon
            sx={{ color: '#4db6ac', fontSize: '60px', margin: '0 auto' }}
          />
        ) : (
          <ErrorIcon
            sx={{ color: '#f44336', fontSize: '60px', margin: '0 auto' }}
          />
        )}
        <Typography variant="h6" className="!my-4 !text-center">
          {t(isSuccessful ? 'schedulePaymentInProgress' : 'paymentSuccess')}
        </Typography>
      </Grid>
      <Grid item xs={12} className="flex !flex-col md:!flex-row justify-around">
        <LendingDetails
          isErrorDetail={!isSuccessful}
          isSuccessDetail={isSuccessful}
          lendingData={lendingData}
        />
      </Grid>
    </Grid>
  );
};

export default ResponseConfirmation;
